/**
 * Custom Fonts Configuration
 *
 * Maps Instagram-style font names to CSS font families.
 * Used for font selector UI and API requests.
 */

export const CORE_FONTS = [
  {
    id: 'Classic',
    name: 'Classic',
    family: 'Playfair Display',
    tier: 'core',
    description: 'Elegant serif for timeless posts'
  },
  {
    id: 'Modern',
    name: 'Modern',
    family: 'Inter',
    tier: 'core',
    description: 'Clean sans-serif for contemporary style'
  },
  {
    id: 'Strong',
    name: 'Strong',
    family: 'Bebas Neue',
    tier: 'core',
    description: 'Bold display for maximum impact'
  },
  {
    id: 'Typewriter',
    name: 'Typewriter',
    family: 'Courier Prime',
    tier: 'core',
    description: 'Monospace for authentic vintage feel'
  },
  {
    id: 'Neon',
    name: 'Neon',
    family: 'Pacifico',
    tier: 'core',
    description: 'Playful script for fun vibes'
  },
  {
    id: 'Literature',
    name: 'Literature',
    family: 'EB Garamond',
    tier: 'core',
    description: 'Formal serif for sophisticated content'
  },
  {
    id: 'Directional',
    name: 'Directional',
    family: 'Teko',
    tier: 'core',
    description: 'Angular design for call-to-action'
  }
];

export const PRO_FONTS = [
  {
    id: 'Signature',
    name: 'Signature',
    family: 'Dancing Script',
    tier: 'pro',
    description: 'Handwritten style for personal touch'
  },
  {
    id: 'Editor',
    name: 'Editor',
    family: 'JetBrains Mono',
    tier: 'pro',
    description: 'Coding font for tech content'
  },
  {
    id: 'Bubble',
    name: 'Bubble',
    family: 'Fredoka One',
    tier: 'pro',
    description: 'Rounded and fun for playful posts'
  },
  {
    id: 'Squeeze',
    name: 'Squeeze',
    family: 'Antonio',
    tier: 'pro',
    description: 'Condensed for tight spaces'
  },
  {
    id: 'Poster',
    name: 'Poster',
    family: 'Libre Baskerville',
    tier: 'pro',
    description: 'Classic poster style'
  },
  {
    id: 'Deco',
    name: 'Deco',
    family: 'Righteous',
    tier: 'pro',
    description: 'Art deco retro aesthetic'
  },
  {
    id: 'Elegant',
    name: 'Elegant',
    family: 'Cormorant Garamond',
    tier: 'pro',
    description: 'Luxury serif for premium brands'
  },
  {
    id: 'Meme',
    name: 'Meme',
    family: 'Comic Neue',
    tier: 'pro',
    description: 'Comic style for humor'
  }
];

export const ALL_FONTS = [...CORE_FONTS, ...PRO_FONTS];

/**
 * Get font by ID
 * @param {string} fontId - Font ID (e.g., 'Classic')
 * @returns {object|undefined} Font object or undefined
 */
export function getFontById(fontId) {
  return ALL_FONTS.find(font => font.id === fontId);
}

/**
 * Check if font is pro tier
 * @param {string} fontId - Font ID
 * @returns {boolean} True if pro font
 */
export function isProFont(fontId) {
  const font = getFontById(fontId);
  return font?.tier === 'pro';
}

/**
 * Get available fonts for user
 * @param {boolean} hasProAccess - Whether user has pro_fonts feature
 * @returns {array} Available fonts
 */
export function getAvailableFonts(hasProAccess = false) {
  return hasProAccess ? ALL_FONTS : CORE_FONTS;
}
